import { BrowserRouter, Route as RouterRoute } from 'react-router-dom'
import { Redirect, Switch } from 'react-router'
import Layout from 'antd/lib/layout'
import {
    Profile,
    Page404,
    SignIn,
    TermsAndConditions,
    SignUp,
    Projects,
    Project,
} from '../../pages'
import Route from '../Route'
import { Users, Setting } from '../../pages/Admin'
import SetPassword from '../../pages/SetPassword'

const Router: React.FC = (): JSX.Element => {
    return (
        <BrowserRouter>
            <Switch>
                <RouterRoute exact path="/">
                    <Redirect to="/projects" />
                </RouterRoute>
                <Route path="/sign-in" title="Sign In" exact>
                    <SignIn />
                </Route>
                <Route path="/sign-up" title="Sign Up" exact>
                    <SignUp />
                </Route>
                <Route path="/set-password" title="Set Password" exact>
                    <SetPassword />
                </Route>
                <Route
                    path="/terms-and-conditions"
                    title="Terms & Conditions"
                    exact
                >
                    <TermsAndConditions />
                </Route>
                <Layout>
                    <Switch>
                        <Route
                            path="/profile"
                            title="Profile"
                            exact
                            authenticated
                        >
                            <Profile />
                        </Route>
                        <Route path="/users" title="Users" exact admin>
                            <Users />
                        </Route>
                        <Route path="/setting" title="Setting" exact admin>
                            <Setting />
                        </Route>
                        <Route
                            path="/projects"
                            title="Projects"
                            exact
                            authenticated
                        >
                            <Projects />
                        </Route>
                        <Route
                            path="/projects/new"
                            title="New Project"
                            exact
                            authenticated
                        >
                            <Project />
                        </Route>
                        <Route
                            path="/projects/:id"
                            title="Missing title"
                            exact
                            authenticated
                        >
                            <Project />
                        </Route>
                        <Route title="Page 404" authenticated>
                            <Redirect to="/projects" />
                        </Route>
                    </Switch>
                </Layout>
                <Route path="/*" title="Page 404">
                    <Page404 />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}

export default Router
